import { render, staticRenderFns } from "./AdminEditRoleComponent.vue?vue&type=template&id=b98d1998&"
import script from "./AdminEditRoleComponent.vue?vue&type=script&lang=js&"
export * from "./AdminEditRoleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports